import React from 'react'
import Header from './includes/header'
import Sidebar from './includes/sidebar';
const Layout = ({ children }) => {
    const user = JSON.parse(localStorage.getItem('user'));
    const hideTopbar = user?.userType === 'Vendor' || user?.userType === 'ADMIN';
    return (
        <div id="layout-wrapper" className={hideTopbar ? 'no-topbar' : ''}>
            <Header />
            <Sidebar />
            <div className="vertical-overlay"></div>
            <div className="main-content">
                <div className="page-content">
                    <div className="container-fluid">
                        {children}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Layout